import { h } from "preact";

const rank_dpe0 = (nb) => {

    if (nb < 70) return "A";
    if (nb < 110) return "B";
    if (nb < 180) return "C";
    if (nb < 250) return "D";
    if (nb < 330) return "E";
    if (nb < 420) return "F";
    return "G";
}
const rank_ges0 = (nb) => {

    if (nb < 6) return "A";
    if (nb < 11) return "B";
    if (nb < 30) return "C";
    if (nb < 50) return "D";
    if (nb < 70) return "E";
    if (nb < 100) return "F";
    return "G";
}

const rank0 = (dpe, ges) => {

    const rank_dpe = rank_dpe0(dpe);
    const rank_ges = rank_ges0(ges);
    return rank_dpe > rank_ges ? rank_dpe : rank_ges

}

import DpeA from "./DpeA";
import DpeB from "./DpeB";
import DpeC from "./DpeC";
import DpeD from "./DpeD";
import DpeE from "./DpeE";
import DpeF from "./DpeF";
import DpeG from "./DpeG";

export default function Dpe({ dpe, ges }) {
    const rank = rank0(dpe, ges);

    if (rank == "A") return <DpeA nb={dpe} />;
    if (rank == "B") return <DpeB nb={dpe} />;
    if (rank == "C") return <DpeC nb={dpe} />;
    if (rank == "D") return <DpeD nb={dpe} />;
    if (rank == "E") return <DpeE nb={dpe} />;
    if (rank == "F") return <DpeF nb={dpe} />;
    if (rank == "G") return <DpeG nb={dpe} />;

}
